<template>
  <div class="echarts">
    <!-- <Loading v-if="loading" /> -->
    <!-- <gaid v-if="loading" /> -->
    <div :id="id" style="height: 400px" class="echarts_list"></div>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  // import Loading from '@comp/loading'
  export default {
    name: '',
    components: {
      // Loading
    },
    props: {
      data: {
        type: Object,
        default() {
          return {}
        }
      },
      id: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        loading: false,
        splitNum: 7,
        charts: null
      }
    },
    watch: {
      $route: {
        handler(nData, oData) {
          const classId = nData.query.classId === oData.query.classId
          if (this.$route.query.seId && classId) {
            this.classDataD()
          }
        },
        deep: true
      }
    },
    mounted() {
      this.classDataD()
      window.addEventListener('resize', this.resizeChart)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resizeChart)
    },
    methods: {
      resizeChart() {
        if (this.charts) this.charts.resize()
      },
      //
      classDataD() {
        let { xTitle, yTitle, title } = this.data
        let piecesArr = []
        let val = -1
        let pieces = {}
        yTitle.forEach((item, index) => {
          if (val === 1 && item < 0) {
            piecesArr.push(pieces)
          }
          if (val === 0 && item >= 0) {
            piecesArr.push(pieces)
          }
          if (item < 0) {
            if (val === 0) {
              pieces.lte = index
            } else {
              pieces = {
                gt: index - 1,
                lte: index,
                color: '#FF8484'
              }
            }
            val = 0
          } else {
            if (val === 1) {
              pieces.lte = index
            } else {
              pieces = {
                gt: index - 1,
                lte: index,
                color: '#62DAAB'
              }
            }
            val = 1
          }
          if (index === yTitle.length - 1) piecesArr.push(pieces)
        })
        this.$nextTick(() => {
          this.charts = echarts.init(document.getElementById(this.id))
          let chartObj = {
            tooltip: {
              trigger: 'axis',
              borderWidth: 0, //设置自定义边框宽度
              backgroundColor: 'none', //设置自定义背景
              extraCssText:
                //额外附加到浮层的css样式，此处为为浮层添加阴影及padding
                'backdrop-filter: blur(10px)',
              formatter: params => {
                var relVal = `<div style='font-weight: 500;line-height: 20px;color: @text-color-secondary;'>${params[0].name}</div>`
                for (var i = 0, l = params.length; i < l; i++) {
                  relVal += `<div class="toolTip">${params[i].marker}${params[i].seriesName}：${params[i].value}</div>`
                }
                return relVal
              }
            },
            xAxis: {
              type: 'category',
              data: xTitle,
              axisLine: {
                show: true,
                lineStyle: {
                  type: 'dashed',
                  color: '#5F8EEC'
                }
              }
            },
            yAxis: {
              type: 'value',
              axisLine: {
                show: false
              }
            },
            visualMap: {
              show: false,
              dimension: 0,
              pieces: piecesArr
            },
            series: [
              // {
              //   name: title,
              //   type: 'line',
              //   symbol: 'circle',
              //   symbolSize: 10,
              //   data: yTitle
              // }
              {
                name: title,
                type: 'line',
                symbol: 'circle',
                symbolSize: 10,
                // label: {
                //   show: true,
                //   formatter: '{c}',
                //   color: '#000000'
                // },
                data: yTitle,
                itemStyle: {
                  normal: {
                    shadowColor: '#BBDEFB',
                    shadowBlur: 10,
                    lineStyle: {
                      width: 2
                    }
                  }
                }
              }
            ]
          }
          let maxVal = 0
          yTitle.forEach(item => {
            maxVal < Math.abs(item) && (maxVal = Math.ceil(Math.abs(item)))
          })
          this.beforeEchart(chartObj, maxVal, { abs: true })
          this.cScroll(chartObj, xTitle, 10)
          this.charts.clear() //清空历史数据
          this.charts.setOption(chartObj)
        })
      },
      beforeEchart(data, yTitle, params = {}) {
        let {
          split = true,
          splitNum = this.splitNum,
          abs = false,
          labelFc = null,
          person = false
        } = params
        let top
        if (data.legend && data.legend.data) {
          let baseNum = Math.ceil(data.legend.data.length / 10)
          top = baseNum * 40 + 24
        }
        //echarts距离处理
        let yName = data.yAxis && data.yAxis.name
        if (!data.grid) data.grid = {}
        if (!data.grid.top) data.grid.top = data.legend ? top : yName ? 44 : 34
        if (!data.grid.bottom) data.grid.bottom = 26
        if (!data.grid.left) data.grid.left = '3.5%'
        if (!data.grid.right) data.grid.right = '3.5%'

        //x轴处理
        if (Array.isArray(data.xAxis)) {
          data.xAxis.forEach(item => {
            if (!item.axisLabel) item.axisLabel = {}
            item.axisLabel.textStyle = {
              fontFamily: 'PingFangSC, PingFangSC-Regular',
              color: '#666666',
              fontSize: 14
            }
            item.axisTick = {
              show: false
            }
          })
        } else {
          if (!data.xAxis.axisLabel) data.xAxis.axisLabel = {}
          data.xAxis.axisLabel.textStyle = {
            fontFamily: 'PingFangSC, PingFangSC-Regular',
            color: '#666666',
            fontSize: 14
          }
          data.xAxis.axisTick = {
            show: false
          }
          !data.xAxis.offset && (data.xAxis.offset = 4)
          if (!data.xAxis.axisLine) {
            data.xAxis.axisLine = {
              show: true,
              lineStyle: {
                color: '#5F8EEC'
              }
            }
          }
        }

        //Y轴处理
        if (!data.yAxis) data.yAxis = {}
        if (Array.isArray(data.yAxis)) {
          data.yAxis.forEach(item => {
            yDataDispose(item)
          })
        } else {
          yDataDispose(data.yAxis)
        }
        //y轴数据处理
        function yDataDispose(yData) {
          if (!yData.splitLine) {
            yData.splitLine = {
              show: false
            }
          }

          if (!yData.axisLabel) yData.axisLabel = {}
          yData.axisLabel.textStyle = {
            fontFamily: 'PingFangSC, PingFangSC-Regular',
            color: '#666666',
            fontSize: 12
          }
          if (!yData.axisLine) {
            yData.axisLine = {
              show: true,
              lineStyle: {
                color: '#5F8EEC'
              },
              itemStyle: {
                color: '#666666'
              }
            }
          }
          if (!yData.splitArea) {
            yData.splitArea = {
              show: true,
              areaStyle: {
                color: ['#A78BFA', '#fff'],
                opacity: 0.04
              }
            }
          }
        }

        //分割处理

        if (split) {
          let max = yTitle
          if (Array.isArray(yTitle)) {
            max = Math.max(...yTitle)
          }
          if (Array.isArray(data.yAxis)) {
            data.yAxis.forEach(item => {
              labelDispose(item, max)
            })
          } else {
            let splitVal = max / splitNum
            if (abs) splitVal = splitVal * 2
            // 人数展示整数
            if (person) {
              if (splitVal % 1) {
                let num = splitVal % 1
                max += splitNum * (1 - num)
              }
              data.yAxis.minInterval = 1
              data.yAxis.interval = max / splitNum
            }
            if (!person) {
              data.yAxis.interval = splitVal
            }
            data.yAxis.max = max

            labelDispose(data.yAxis, max)
          }
        }
        function labelDispose(label, max) {
          //label处理
          label.axisLabel.formatter = value => {
            var texts = []
            let nums = Math.floor(max / splitNum)
            texts.push(+value.toFixed(nums ? 0 : 1) + (labelFc && labelFc()))
            return texts
          }
        }
      },
      //图表滚动条
      cScroll(data, xTitle, num) {
        //如果超过num个则显示滚动条
        if (xTitle.length > num) {
          let endVal = +(100 * (num / xTitle.length)).toFixed(2)
          data.grid.bottom = 64
          data.dataZoom = [
            {
              start: 0, //默认为0
              end: endVal, //默认为100
              type: 'slider',
              show: true,
              handleIcon: `M 100, 100
                                  m -75, 0
                                  a 75,75 0 1,0 150,0
                                  a 75,75 0 1,0 -150,0`,
              handleSize: '85%',
              handleStyle: {
                color: '#ddeeff',
                borderWidth: 0
              },
              xAxisIndex: [0],
              moveHandleSize: 0, //移动手柄尺寸高度
              height: 8, //组件高度
              left: 40, //左边的距离
              right: 40, //右边的距离
              bottom: 14, //底部的距离
              fillerColor: 'rgba(203, 214, 255, 0.6)', //线条颜色
              borderColor: 'transparent', //线条边框颜色
              backgroundColor: '#F8F8F8', //两边未选中的滑动条区域的颜色
              showDataShadow: false, //是否显示数据阴影 默认auto
              showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
              realtime: true, //是否实时更新
              filterMode: 'filter',
              brushSelect: false //关闭十字架选中
            }
          ]
        }
      }
    }
  }
</script>
<style lang="less" scoped>
  .score {
    height: 100%;
    .left {
      float: left;
    }
    .right {
      float: right;
    }
    .table_div {
      height: calc(100% - 50px);
      padding: 20px 0;
    }
  }
</style>
